export default "__VITE_ASSET__ncELJ34k__"